import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useParams} from "react-router-dom";
import * as XLSX from "xlsx";
import {saveAs} from "file-saver";

export default function EntrepreneurDetail(prop) {
    let {slug} = useParams();

    let [data, setData] = React.useState(null);
    let [detail, setDetail] = React.useState(null);
    let [awardListing, setAwardListing] = React.useState(null);
    let [intellectualListing, setIntellectualListing] = React.useState(null);
    let [productsListing, setProductsListing] = React.useState(null);

    React.useEffect(() => {

        (async function() {
            try {
                const resView = await getView();
                setData(resView);

                const resDetail = await getDetail();
                if(prop !== null && prop.lang === 'en') {
                    resDetail.title = resDetail.title_en;
                    resDetail.address = resDetail.address_en;
                    resDetail.phone = resDetail.phone_en;
                    resDetail.entrepreneurType.title = resDetail.entrepreneurType.title_en;
                    resDetail.entrepreneurProduct.title = resDetail?.entrepreneurProduct?.title_en;
                    resDetail.entrepreneurService.title = resDetail?.entrepreneurService?.title_en;
                    resDetail.product = resDetail.product_en;
                    resDetail.intellectual = resDetail.intellectual_en;
                    resDetail.awards = resDetail.awards_en;
                }

                if(resDetail) {
                    setDetail(resDetail);

                    let title = (prop.lang === 'en' ? 'Entrepreneur':'ข้อมูลผู้ประกอบการ') + ' - ' + resDetail.title + ' | NCSA';
                    document.title = title;
                    const elDesc = document.querySelector("meta[name='description']");
                    elDesc.setAttribute('content', title);
                    const elOgTitle = document.querySelector("meta[property='og:title']");
                    elOgTitle.setAttribute('content', title);
                    const elOgDesc = document.querySelector("meta[property='og:description']");
                    elOgDesc.setAttribute('content', title);
                    const elOgImage = document.querySelector("meta[property='og:image']");
                    elOgImage.setAttribute('content', Config.baseUrl + 'images/default.jpg');
                    const elOgUrl = document.querySelector("meta[property='og:url']");
                    elOgUrl.setAttribute('content', window.location.href);

                    let awardResult = await getAward(resDetail.id);
                    setAwardListing(awardResult);
                    let intellectualResult = await getIntellectual(resDetail.id);
                    setIntellectualListing(intellectualResult);
                    let productsResult = await getProducts(resDetail.id);
                    setProductsListing(productsResult);
                }
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getView() {
        const response = await fetch(Config.apiUrl +'/entrepreneurBanner/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getDetail() {
        const response = await fetch(Config.apiUrl +'/entrepreneur/viewSlug', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                slug: slug
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getAward(id) {
        const response = await fetch(Config.apiUrl +'/entrepreneurAward/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                entrepreneurId: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getIntellectual(id) {
        const response = await fetch(Config.apiUrl +'/entrepreneurIntellectual/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                entrepreneurId: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getProducts(id) {
        const response = await fetch(Config.apiUrl +'/entrepreneurProducts/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                entrepreneurId: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onExportExcel = async () => {
        if(detail) {
            let array = [];
            let json = {
                title: detail.title,
                entrepreneurType: detail?.entrepreneurType?.title,
                entrepreneurProduct: detail?.entrepreneurProduct?.title,
                entrepreneurService: detail?.entrepreneurService?.title,
                address: detail?.address,
                phone: detail?.phone + (detail?.phone_detail ? detail?.phone_detail:''),
                email: detail?.email,
                website: detail?.website,
                googlemapUrl: detail?.googlemapUrl,
                title_en: detail.title_en,
                entrepreneurType_en: detail?.entrepreneurType?.title_en,
                entrepreneurProduct_en: detail?.entrepreneurProduct?.title_en,
                entrepreneurService_en: detail?.entrepreneurService?.title_en,
                address_en: detail?.address_en,
                phone_en: detail?.phone_en + (detail?.phone_detail_en ? detail?.phone_detail_en:''),
            };
            array.push(json);
            let finalHeaders = [['ชื่อผู้ประกอบการ', 'ประเภท', 'ผลิตภัณฑ์', 'บริการ', 'ที่อยู่', 'โทรศัพท์', 'อีเมล', 'เว็บไซต์', 'Google Map', 'ชื่อผู้ประกอบการ (EN)', 'ประเภท (EN)', 'ผลิตภัณฑ์ (EN)', 'บริการ (EN)', 'ที่อยู่ (EN)', 'โทรศัพท์ (EN)']];
            const workbook = XLSX.utils.book_new();
            const worksheet= XLSX.utils.json_to_sheet(array, { origin: 'A2', skipHeader: true });
            XLSX.utils.sheet_add_aoa(worksheet, finalHeaders);

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
            saveAs(blob, `export_ncsa_entrepreneur.xlsx`);
        }
        else {
            //toast.error("ไม่พบข้อมูลสมาชิก");
        }
    };

    const onExportIntellectual = async () => {
        if(intellectualListing) {
            let array = [];
            for(let rs of intellectualListing.rows) {
                let json = {
                    company: detail.title,
                    title: rs.title,
                    title_en: rs.title_en,
                    issueNo: rs.issueNo,
                    registerNo: rs.registerNo,
                    url: rs.url,
                };
                array.push(json);
            }
            let finalHeaders = [['ชื่อผู้ประกอบการ', 'ชื่อทรัพย์สินทางปัญญา', 'ชื่อทรัพย์สินทางปัญญา (En)', 'เลขที่คำขอ', 'เลขที่จดทะเบียน', 'ลิ้งค์']];
            const workbook = XLSX.utils.book_new();
            const worksheet= XLSX.utils.json_to_sheet(array, { origin: 'A2', skipHeader: true });
            XLSX.utils.sheet_add_aoa(worksheet, finalHeaders);

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
            saveAs(blob, `export_ncsa_entrepreneur.xlsx`);
        }
        else {
            //toast.error("ไม่พบข้อมูลสมาชิก");
        }
    };

    return (
        <>
            <div className="section section-banner small">
                {
                    data?.image ? <img src={Config.fileUpload + 'entrepreneur_banner/' + data?.image} alt="" /> : ''
                }
                <div className="container">
                    <h1 className="h2 textrow">
                        <span data-aos="fade-up">{prop.lang === 'en' ? 'Entrepreneur':'ข้อมูลผู้ประกอบการ'}</span>
                    </h1>
                    <p data-aos="fade-in">
                        <NavLink to="/">{prop.lang === 'en' ? 'Home':'หน้าแรก'}</NavLink> / <NavLink to='#'>{prop.lang === 'en' ? 'NCSA Database':'ฐานข้อมูลของ สกมช.'}</NavLink> / <NavLink to={ (prop.lang === 'en' ? '/en':'') + "/entrepreneur"}>{prop.lang === 'en' ? 'Entrepreneur':'ข้อมูลผู้ประกอบการ'}</NavLink>
                    </p>
                </div>
            </div>

            <div className="section">
                <div className="container " data-aos="fade-in">
                    <div className="content">
                        <div className="card-infos" data-aos="fade-in">
                            <h3 className="fs-20">{detail?.title}
                                <button className="btn btn-xs btn-green w-130 float-end" onClick={onExportExcel}>
                                    {prop.lang === 'en' ? 'Export Excel':'Export Excel'}
                                </button>
                            </h3>

                            <hr className="mb-4" />

                            <div className="row g-2">
                                <div className="col-12">
                                    <ul className="infos-list m-0">
                                        {
                                            detail?.entrepreneurType?.title ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Type' : 'ประเภท'} :</h6>
                                                    <p>{detail?.entrepreneurType?.title}</p>
                                                </li> : ''
                                        }
                                        {
                                            detail?.entrepreneurProduct?.title ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Product' : 'ผลิตภัณฑ์'} :</h6>
                                                    <p>{detail?.entrepreneurProduct?.title}</p>
                                                </li>: ''
                                        }
                                        {
                                            detail?.entrepreneurService?.title ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Service' : 'บริการ'} :</h6>
                                                    <p>{detail?.entrepreneurService?.title}</p>
                                                </li>: ''
                                        }
                                    </ul>
                                </div>

                                <div className="col-12">
                                    <hr className="my-md-3 my-2" />
                                </div>

                                <div className="col-12">
                                    <ul className="infos-list m-0">

                                        {
                                            detail?.address ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Address':'ที่อยู่'} :</h6>
                                                    <p dangerouslySetInnerHTML={{__html: detail?.address.replace(/\n/g, "<br />")}}></p>
                                                </li> : ''
                                        }

                                        {
                                            detail?.phone ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Phone':'โทรศัพท์'} :</h6>
                                                    <p>{detail?.phone} {detail?.phone_detail ? detail?.phone_detail:''}</p>
                                                </li> : ''
                                        }

                                        {
                                            detail?.email ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Email':'อีเมล'} :</h6>
                                                    <p><a className="link-primary"
                                                          href={'mailto:' + detail?.email}>{detail?.email}</a></p>
                                                </li> : ''
                                        }

                                        {
                                            detail?.website ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Website':'เว็บไซต์'} :</h6>
                                                    <p><a className="link-primary" href={detail?.website} target="_blank">{detail?.website}</a></p>
                                                </li> : ''
                                        }
                                    </ul>
                                </div>

                                {
                                    detail?.googlemapUrl ?
                                        <div className="col-12">
                                            <div className="google-map h-300 mt-4">
                                                <iframe
                                                    src={detail?.googlemapUrl}
                                                    width="600" height="450" style={{border: 0}} allowFullScreen=""
                                                    loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                                            </div>
                                        </div> : ''
                                }

                                <div className="col-12 pt-sm-5 pt-4">
                                    {
                                        productsListing !== null && productsListing.rows.length > 0 ?
                                            <div className="card-accordion">
                                                <div className="card-header" data-bs-toggle="collapse"
                                                     data-bs-target="#collapse1" aria-expanded="false">
                                                    <h2>{prop.lang === 'en' ? 'Products':'ผลิตภัณฑ์หรือบริการ อื่นๆ'}</h2>
                                                    <span className="arrow"></span>
                                                </div>

                                                <div id="collapse1" className="accordion-collapse collapse">
                                                    <div className="card-body">
                                                        {
                                                            productsListing.rows.map((row, index) => {
                                                                return (
                                                                    <div key={index} className="mb-3">
                                                                        <h3>{prop.lang === 'en' ? row.title_en:row.title}</h3>
                                                                        <p className="mb-0">{prop.lang === 'en' ? row.detail_en:row.detail}</p>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div> : ''
                                    }

                                    {
                                        intellectualListing !== null && intellectualListing.rows.length > 0 ?
                                            <div className="card-accordion">
                                                <div className="card-header" data-bs-toggle="collapse"
                                                     data-bs-target="#collapseIntellectual" aria-expanded="false">
                                                    <h2>{prop.lang === 'en' ? 'Intellectual property':'ทรัพย์สินทางปัญญา'}</h2>
                                                    <span className="arrow"></span>
                                                </div>

                                                <div id="collapseIntellectual" className="accordion-collapse collapse">
                                                    <div className="card-body">
                                                        <button className="btn btn-xs btn-green w-130 float-end" onClick={onExportIntellectual} style={{zIndex: 9999}}>
                                                            {prop.lang === 'en' ? 'Export Excel':'Export Excel'}
                                                        </button>

                                                        {
                                                            intellectualListing.rows.map((row, index) => {
                                                                return (
                                                                    <div key={index} className="mb-3">
                                                                        <h3>{prop.lang === 'en' ? row.title_en:row.title}</h3>
                                                                        <p className="mb-0">{prop.lang === 'en' ? 'Issue No : ' + row.issueNo:'เลขที่คำขอ : ' + row.issueNo}</p>
                                                                        <p className="mb-0">{prop.lang === 'en' ? 'Register No : ' + row.registerNo:'เลขที่จดทะเบียน : ' + row.registerNo}</p>
                                                                        <p className="mb-0">{prop.lang === 'en' ? 'URL : ':'ลิ้งค์ : '} <a href={row.url} target="_blank" className="text-primary">{prop.lang === 'en' ? 'Click':'คลิก'}</a></p>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div> : ''
                                    }

                                    {
                                        awardListing !== null && awardListing.rows.length > 0 ?
                                            <div className="card-accordion">
                                                <div className="card-header" data-bs-toggle="collapse"
                                                     data-bs-target="#collapseAward" aria-expanded="false">
                                                    <h2>{prop.lang === 'en' ? 'Awards received':'รางวัลที่ได้รับ'}</h2>
                                                    <span className="arrow"></span>
                                                </div>

                                                <div id="collapseAward" className="accordion-collapse collapse">
                                                    <div className="card-body">
                                                        {
                                                            awardListing.rows.map((row, index) => {
                                                                return (
                                                                    <div key={index} className="mb-3">
                                                                        <h3>{prop.lang === 'en' ? row.title_en:row.title}</h3>
                                                                        <p className="mb-0">{prop.lang === 'en' ? 'Providing agency : ' + row.institution_en:'หน่วยงานที่มอบ : ' + row.institution}</p>
                                                                        {
                                                                            row.receivedDate ?
                                                                                <p className="mb-0">{prop.lang === 'en' ? 'Award date : ' + Utils.dateTimeDMY(row.receivedDate):'วันทีรับรางวัล : ' + Utils.dateTimeDMY(row.receivedDate)}</p> : ''
                                                                        }
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div> : ''
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 